module.exports = __webpack_public_path__ + "static/img/Jamie-Humphreys.00fdbaf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jamie-Humphreys.jpg
// module id = 1UH3
// module chunks = 0